module.exports = __webpack_public_path__ + "faq.804db8457b9fd35476fa.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/faq.jpg
// module id = ../../../../../src/assets/images/backgrounds/faq.jpg
// module chunks = styles